(()=>{
  const STORAGE_KEY='fc-lead-popup-seen-v1';

  const init=()=>{
    const root=document.querySelector('[data-fc-lead-popup]');
    if(!root||root.dataset.fcReady==='true')return;
    root.dataset.fcReady='true';

    const closeButtons=[...root.querySelectorAll('[data-fc-lead-close]')];
    const goalButtons=[...root.querySelectorAll('[data-fc-lead-goal]')];
    const tagsInput=root.querySelector('[data-fc-lead-tags]');
    const emailInput=root.querySelector('#FcLeadEmail');
    const successPanel=root.querySelector('[data-fc-lead-step="success"]');
    const emailPanel=root.querySelector('[data-fc-lead-step="email"]');
    const forced=new URLSearchParams(window.location.search).get('fc-popup')==='preview';
    const designMode=Boolean(window.Shopify&&window.Shopify.designMode);
    const hasSuccess=successPanel&&!successPanel.hidden;
    const hasError=emailPanel&&!emailPanel.hidden;
    let previousFocus=null;

    const storage={
      get(){try{return window.localStorage.getItem(STORAGE_KEY)}catch(error){return null}},
      set(){try{window.localStorage.setItem(STORAGE_KEY,'1')}catch(error){}
      }
    };

    const setStep=step=>{
      root.querySelectorAll('[data-fc-lead-step]').forEach(panel=>{
        panel.hidden=panel.dataset.fcLeadStep!==step;
      });
      root.dataset.fcActiveStep=step;
      if(step==='email')window.setTimeout(()=>emailInput?.focus(),40);
    };

    const open=()=>{
      previousFocus=document.activeElement;
      root.hidden=false;
      root.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('fc-lead-popup-open');
      document.body.classList.add('fc-lead-popup-open');
      if(hasSuccess)setStep('success');
      else if(hasError)setStep('email');
      else setStep('goals');
      window.setTimeout(()=>root.querySelector('[data-fc-lead-close]')?.focus(),50);
    };

    const close=()=>{
      if(!forced&&!designMode)storage.set();
      root.setAttribute('aria-hidden','true');
      root.hidden=true;
      document.documentElement.classList.remove('fc-lead-popup-open');
      document.body.classList.remove('fc-lead-popup-open');
      previousFocus?.focus?.();
    };

    goalButtons.forEach(button=>button.addEventListener('click',()=>{
      const goal=button.dataset.fcLeadGoal||'';
      if(tagsInput)tagsInput.value=`newsletter,Femme Cycle,popup lead,interesse ${goal}`;
      setStep('email');
    }));

    closeButtons.forEach(button=>button.addEventListener('click',close));
    root.querySelector('[data-fc-lead-complete]')?.addEventListener('click',storage.set);
    root.addEventListener('keydown',event=>{
      if(event.key==='Escape'){
        event.preventDefault();
        close();
        return;
      }
      if(event.key!=='Tab')return;
      const focusable=[...root.querySelectorAll('button:not([hidden]):not([disabled]),a[href]:not([hidden]),input:not([hidden]):not([disabled])')]
        .filter(element=>element.offsetParent!==null);
      if(!focusable.length)return;
      const first=focusable[0];
      const last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    });

    if(hasSuccess)storage.set();
    if(forced||designMode||hasSuccess||hasError||!storage.get())open();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
